/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Header from 'parts/Header';
import Hero from 'parts/Hero';
import Service from 'parts/Service';
import Solutions from 'parts/Solutions';
import Portfolio from 'parts/Portfolio';
import Advantage from 'parts/Advantage';
import Technologies from 'parts/Technologies';
import EnterpriseSupport from 'parts/EnterpriseSupport';
import Testimonial from 'parts/Testimonial';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';
import OurClients from 'parts/OurClients';
import Data from 'json/landingPage.json';

export default class LandingPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header {...this.props} />
        <Hero {...this.props} />
        <Service data={Data.service} />
        <Solutions data={Data.solutions} />
        <Portfolio data={Data.portfolio} />
        <Advantage data={Data.advantage} />
        <OurClients data={Data.clients} />
        <Technologies data={Data.technologies} />
        <EnterpriseSupport data={Data.enterpriseSupport} />
        <Testimonial data={Data.testimonial} />
        <Discuss />
        <Footer />
      </>
    );
  }
}
